import React from 'react';
import { CButton } from '@coreui/react';

interface ChatErrorProps {
  message: string;
  onRetry: () => void;
}

const ChatError = (props: ChatErrorProps) => {
  const { message, onRetry } = props;

  return (
    <div className="d-flex flex-column w-100 h-100 align-items-center justify-content-center">
      <div className="text-danger font-weight-bold mb-2">{message || 'Something went wrong loading this chat.'}</div>
      <CButton color="primary" onClick={onRetry}>Retry</CButton>
    </div>
  );
};

export default ChatError;
